import "../../../assets/css/variables.css";
import { CSSProperties } from "react";

export const styles  ={
    modal: {
        v: {
            overlay: {
                zIndex: 100,
                display: "flex",
                justifyContent: "center",
                alignItems: "start"
            },
            content: {
                height: 'min-content',
                // Was '#FAF8F6' hardcoded: in dark mode the modal stayed light while its text turned
                // light too (title, student name, typed notes all invisible). --main-bg is that same
                // #FAF8F6 in light and the surface in dark. (Esteban, 2026-10-17)
                background: 'var(--main-bg)',
                borderRadius: '15px',
                padding: "0",
                overflow: "hidden",
                inset: "unset",
                // Phones: the window was 381px on a 375px screen, and once capped it shrank to its
                // narrowest child (281px). The minimum fills a phone; every window using this
                // component is already wider than 560px on PC, so PC does not change. (2026-10-18)
                maxWidth: "calc(100vw - 16px)",
                minWidth: "min(calc(100vw - 16px), 560px)",
                border: "none",
                boxShadow: "0px 0px 10px -5px rgba(0, 0, 0, 0.75)"
            }
        },
        container: {
            v: <CSSProperties> {
                flexDirection: "column",
                display: "flex"
            },
            header: {
                v: <CSSProperties> {
                    display: "flex",
                    alignItems: "center",
                    // 24px on PC as before; less on phones so the title fits next to the close button.
                    padding: "clamp(12px, 4vw, 24px)",
                },
                title: {
                    v: <CSSProperties> {
                        display: "flex",
                        color: "var(--txt-color)",
                        width: "100%",
                        minWidth: 0,
                    }
                },
                close: {
                    v: <CSSProperties> {
                        display: "flex",
                        verticalAlign: "top"
                    },
                    button: {
                        v: <CSSProperties> {
                            color: "var(--txt-color)",
                            background: "var(--main-bg)",
                            borderRadius: "50%",
                            width: "40px",
                            height: "40px",
                            border: "1px solid #CCCCCC",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            left: "1px",
                            position: "relative"
                        }
                    }
                }
            },
            buttons: {
                v: <CSSProperties> {
                    display : "inline-block",
                    zIndex : 2,
                    height: "0px",
                    position: "relative",
                    padding: "0 32px",
                },
                content: {
                    v : <CSSProperties> {
                        transform: "translate( 0 , -50%)",
                        display : "flex"
                    },
                    hex: {
                        content: {
                            v: <CSSProperties> {
                                textAlign: "right",
                                position: "sticky",
                                left: "0px"
                            },
                            buttonList: {
                                v: <CSSProperties> {
                                    display : "inline-flex"
                                },
                                cardButton: {
                                    v: <CSSProperties> {
                                        display : "inline-grid",
                                        margin : "0px 5px",
                                        width : "fit-content"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            body: {
                v: <CSSProperties> {
                    // 32px on PC as before; on a 375px phone 32px per side ate a fifth of the width.
                    padding: "clamp(12px, 4vw, 32px)",
                    border: "1px solid rgba(0, 0, 0, 0.175)",
                    borderRadius: "15px",
                    background: 'var(--wa-superficie)'
                },
                content: {
                    v: <CSSProperties> {
                        width: "100%",
                        maxHeight: "70vh",
                        minHeight: "50vh",
                        display: "flex",
                        flexDirection: "column",
                        overflowX: "hidden",
                        overflowY: "auto",
                    }
                }
            }
        }
    }
}